export default "__VITE_ASSET__D0UIjLT9__"